import { shallowRef, shallowReactive, computed } from 'vue'

export function useTableRowSelection() {
  
  const selectedIdsSet = shallowReactive(new Set<number>())
  const allItemIds = shallowRef<number[]>([])
  const selectedIds = computed(() => Array.from(selectedIdsSet))
  const selectedCount = computed(() => selectedIdsSet.size)
  const isAllSelected = computed(
    () => allItemIds.value.length > 0 && allItemIds.value.every((id) => selectedIdsSet.has(id))
  )
  const isIndeterminate = computed(() => {
    const count = allItemIds.value.filter((id) => selectedIdsSet.has(id)).length
    return count > 0 && count < allItemIds.value.length
  })
  const hasSelection = computed(() => selectedIdsSet.size > 0)

  function selectItem(itemId: number) {
    selectedIdsSet.add(itemId)
  }

  function deselectItem(itemId: number) {
    selectedIdsSet.delete(itemId)
  }

  function toggleItem(itemId: number) {
    if (selectedIdsSet.has(itemId)) deselectItem(itemId)
    else selectedIdsSet.add(itemId)
  }

  function selectAll() {
    selectedIdsSet.clear()
    for (const id of allItemIds.value) selectedIdsSet.add(id)
  }

  function deselectAll() {
    selectedIdsSet.clear()
  }

  function isItemSelected(itemId: number) {
    return selectedIdsSet.has(itemId)
  }

  function setAvailableItems(itemIds: number[]) {
    allItemIds.value = itemIds
  }

  function removeItems(itemIds: number[]) {
    for (const id of itemIds) selectedIdsSet.delete(id)
  }

  function reset() {
    selectedIdsSet.clear()
    allItemIds.value = []
  }

  return {
    selectedIds,
    allItemIds,
    selectedCount,
    isAllSelected,
    isIndeterminate,
    hasSelection,
    selectItem,
    toggleItem,
    selectAll,
    deselectAll,
    isItemSelected,
    setAvailableItems,
    removeItems,
    reset
  }
}
